// Review annotations must not replace a landing page's background behind light
// text. Use the same scoped rules in the live review and its downloaded copy.
const rules: { selector: string; styles: Record<string, string> }[] = [
  {
    selector: '[data-lp-document] .giga-parent-block-container',
    styles: {
      'background-color': 'transparent',
      'border-color': '#9c7cd6',
      'border-width': '1px',
      'border-style': 'solid',
    },
  },
  {
    selector: '[data-lp-document] .giga-suggested-link, [data-lp-document] [data-giga-new-link="true"]',
    styles: {
      'background-color': 'transparent',
      color: 'inherit',
      'text-decoration': 'underline dotted',
      'font-family': 'inherit',
      'font-size': 'inherit',
      'font-weight': 'inherit',
      'white-space': 'normal',
      animation: 'none',
    },
  },
];

export const LANDING_PAGE_REVIEW_CSS = rules
  .map(
    ({ selector, styles }) =>
      `${selector}{${Object.entries(styles)
        .map(([name, value]) => `${name}:${value}!important`)
        .join(';')}}`
  )
  .join('\n');

export function styleLandingPageReviewExport(doc: Document): void {
  rules.forEach(({ selector, styles }) => {
    doc.querySelectorAll<HTMLElement>(selector).forEach((element) => {
      Object.entries(styles).forEach(([name, value]) => element.style.setProperty(name, value));
    });
  });
}
